import { Component } from '@angular/core';
import { SendEventAllianceIframe } from '@shared/utility/send-event-alliance-iframe';

@Component({
  selector: 'app-gray-zone',
  templateUrl: './gray-zone.component.html',
  styleUrls: ['./gray-zone.component.css'],
})
export class GrayZoneComponent {
  constructor(private sendEventAllianceIframe: SendEventAllianceIframe) {}

  public sendEventIframe(): void {
    this.sendEventAllianceIframe.sendMessage('Zona Gris Proceso');
  }
}
